// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0fe9a756","952":"258c7ee1"}[chunkId] + ".chunk.js";
};